import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import MentalWellbeingModal from '../../shared/modal/MentalWellbeingModal';
import { DialSlider } from '../questions/dialSlider/DialSlider';
import { AssessmentPageItem } from '../types/AssessmentPageItem';

export function MentalHealth2({
  assessmentValues,
  questionid,
  questionHeading,
  questionText,
  onSetValue,
}: AssessmentPageItem) {
  const { t } = useTranslation();
  const [modalIsOpen, setModalIsOpen] = useState(true);

  const textValue = [t('MH001'), t('MH002')];

  const modalClickHandler = useCallback(() => {
    setModalIsOpen(false);
  }, [modalIsOpen]);

  return (
    <>
      {modalIsOpen && (
        <MentalWellbeingModal modalIsOpen={modalIsOpen} modalClickHandler={modalClickHandler} />
      )}
      <div className="question_container" id={questionid}>
        <h1>{questionHeading}</h1>
        <p>{questionText}</p>

        <div className="question_block_wide gad center">
          <div className="answer_block">
            <DialSlider
              questionid="mood_rating"
              width="_wide center"
              questionTitle={t('assessment.question.mood_rating')}
              textValue={textValue}
              scale={5}
              onSetValue={onSetValue}
              assessmentValues={assessmentValues}
            />
          </div>
        </div>
      </div>
    </>
  );
}
